export default function replaceAllSpaces(stringToClean?: string) {
  if (!stringToClean) return null
  return stringToClean.replace(/\s/g, '-')
}
